import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatSizeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_size"}/>
}
